import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/drupal/node--article.tsx");
